import React, { useMemo } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { buildWorkspaceTabs } from './navigation/workspaceTabs';
import './WorkspaceTabs.scss';

const WorkspaceTabs = ({ access, translate }) => {
    const location = useLocation();
    const workspace = useMemo(
        () => buildWorkspaceTabs(location.pathname, access, translate),
        [location.pathname, access, translate]
    );

    if (!workspace) return null;

    return (
        <nav className="workspace-tabs" aria-label={workspace.label}>
            <span className="workspace-tabs__label">{workspace.label}</span>
            <div className="workspace-tabs__list">
                {workspace.tabs.map((tab) => {
                    const isActive = tab.id === workspace.activeId;
                    return (
                        <NavLink
                            key={tab.id}
                            to={tab.route}
                            aria-current={isActive ? 'page' : undefined}
                            className={`workspace-tabs__tab${isActive ? ' workspace-tabs__tab--active' : ''}`}
                        >
                            {tab.label}
                        </NavLink>
                    );
                })}
            </div>
        </nav>
    );
};

export default WorkspaceTabs;
